import "driver.js/dist/driver.css";
import * as bootstrap from "bootstrap";
import "swiper/css/bundle";
import Swiper from "swiper/bundle";
import initStorefrontPortal from "@/portal/storefront";

window.bootstrap = bootstrap;
window.Swiper = Swiper;

initStorefrontPortal();

import { initReceiptDelivery } from './receipt-delivery';
initReceiptDelivery();
